<template>
  <div class="container w-100 mt-3" data-tour="filters">
    <div class="row">
      <div class="col-3 mb-3 pe-2">
        <label for="teacherSelect">Docente</label>
        <Multiselect
            class="multiselectCustom"
            id="teacherSelect"
            v-model="selectedTeacher"
            :loading="isLoadingTeachers"
            :disabled="hasOnlyOneTeacher"
            :options="teachers"
            :showLabels="false"
            :track-by="'username'"
            :label="'name'"
            :allow-empty="false"
            placeholder="Selecione o docente"
            @select="onTeacherChange"
        >
          <template #noOptions>
            <span>Sem Docentes</span>
          </template>
        </Multiselect>
      </div>

      <div class="col-3 pe-2 mb-3">
        <label for="classesSelect" class="">Unidades</label>

        <Multiselect
            class="multiselectCustom"
            id="branchesSelect"
            v-model="selectedBranches"
            :loading="isLoadingBranches"
            :options="branches"
            :showLabels="false"
            :track-by="'id'"
            :label="'name'"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            placeholder=""
            @select="onBranchChange"
            @remove="onBranchChange"
        >
          <template #selection="slotProps">
            <span v-if="branches.length > 0 && slotProps.values.length === branches.length">Todas as unidades</span>
            <span v-else-if="slotProps.values.length > 0">{{ slotProps.values.length }} unidade{{ slotProps.values.length > 1 ? 's' : '' }} selecionada{{ slotProps.values.length > 1 ? 's' : '' }}</span>
            <span v-else>Selecione as unidades</span>
          </template>

          <template #beforeList>
            <div class="m-2 flex justify-self-center" v-if="branches.length > 0">
              <button @click="onSelectAllBranches"
                      v-if="selectedBranches.length === 0"
                      class="btn btn-secondary">Selecionar todas
              </button>

              <button @click="onUnselectAllBranches"
                      v-else
                      class="btn btn-secondary">Deselecionar todas
              </button>
            </div>
          </template>

          <template #noOptions>
            <div class="flex justify-self-center">
              <span>Sem unidades</span>
            </div>
          </template>
        </Multiselect>
      </div>

      <div class="col-3 pe-2 mb-3">
        <label for="laboratoriesSelect">Laboratórios</label>

        <Multiselect
            class="multiselectCustom"
            id="laboratoriesSelect"
            v-model="selectedLaboratories"
            :loading="isLoadingLaboratories"
            :options="laboratories"
            :showLabels="false"
            :track-by="'id'"
            :label="'title'"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            placeholder=""
        >
          <template #selection="slotProps">
            <span v-if="laboratories.length > 0 && slotProps.values.length === laboratories.length">Todos os laboratórios</span>
            <span v-else-if="slotProps.values.length > 0">{{ slotProps.values.length }} laboratório{{ slotProps.values.length > 1 ? 's' : '' }} selecionado{{ slotProps.values.length > 1 ? 's' : '' }}</span>
            <span v-else>Selecione os laboratórios</span>
          </template>

          <template #beforeList>
            <div class="m-2 flex justify-self-center" v-if="laboratories.length > 0">
              <button @click="onSelectAllLaboratories"
                      v-if="selectedLaboratories.length === 0"
                      class="btn btn-secondary">Selecionar todos
              </button>

              <button @click="onUnselectAllLaboratories"
                      v-else
                      class="btn btn-secondary">Deselecionar todos
              </button>
            </div>
          </template>

          <template #noOptions>
            <div class="flex justify-self-center">
              <span>Sem laboratórios</span>
            </div>
          </template>
        </Multiselect>
      </div>

      <div class="col-3 pe-2 mb-3">
        <label for="classesSelect" class="">Modalidades</label>

        <Multiselect
            class="multiselectCustom"
            id="courseTypesSelect"
            v-model="selectedCourseTypes"
            :loading="isLoadingCourseTypes"
            :options="courseTypes"
            :showLabels="false"
            :track-by="'id'"
            :label="'name'"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            placeholder=""
            @select="onCourseTypeChange"
            @remove="onCourseTypeChange"
        >
          <template #selection="slotProps">
            <span v-if="courseTypes.length > 0 && slotProps.values.length === courseTypes.length">Todas as modalidades</span>
            <span v-else-if="slotProps.values.length > 0">{{ slotProps.values.length }} modalidade{{ slotProps.values.length > 1 ? 's' : '' }} selecionada{{ slotProps.values.length > 1 ? 's' : '' }}</span>
            <span v-else>Selecione as modalidades</span>
          </template>

          <template #beforeList>
            <div class="m-2 flex justify-self-center" v-if="courseTypes.length > 0">
              <button @click="onSelectAllCourseTypes"
                      v-if="selectedCourseTypes.length === 0"
                      class="btn btn-secondary">Selecionar todas
              </button>

              <button @click="onUnselectAllCourseTypes"
                      v-else
                      class="btn btn-secondary">Deselecionar todas
              </button>
            </div>
          </template>

          <template #noOptions>
            <div class="flex justify-self-center">
              <span>Sem modalidades</span>
            </div>
          </template>
        </Multiselect>
      </div>

      <div class="col-3 pe-2 mb-3">
        <label for="classesSelect" class="">Turmas</label>

        <Multiselect
            class="multiselectCustom"
            id="classesSelect"
            v-model="selectedClasses"
            :loading="isLoadingClasses"
            :options="classes"
            :showLabels="false"
            :track-by="'id'"
            :label="'name'"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            placeholder=""
            @select="onClassChange"
            @remove="onClassChange"
        >
          <template #selection="slotProps">
            <span v-if="classes.length > 0 && slotProps.values.length === classes.length">Todas as turmas</span>
            <span v-else-if="slotProps.values.length > 0">{{ slotProps.values.length }} turma{{ slotProps.values.length > 1 ? 's' : '' }} selecionada{{ slotProps.values.length > 1 ? 's' : '' }}</span>
            <span v-else>Selecione as turmas</span>
          </template>

          <template #beforeList>
            <div class="m-2 flex justify-self-center" v-if="classes.length > 0">
              <button @click="onSelectAllClasses"
                      v-if="selectedClasses.length === 0"
                      class="btn btn-secondary">Selecionar todas
              </button>

              <button @click="onUnselectAllClasses"
                      v-else
                      class="btn btn-secondary">Deselecionar todas
              </button>
            </div>
          </template>

          <template #noOptions>
            <div class="flex justify-self-center">
              <span>Sem turmas</span>
            </div>
          </template>
        </Multiselect>
      </div>

      <div class="col-3 pe-2 mb-3">
        <label for="studentsSelect">Estudantes</label>

        <Multiselect
            class="multiselectCustom"
            id="studentsSelect"
            v-model="selectedStudents"
            :loading="isLoadingStudents"
            :options="getStudents()"
            :track-by="'username'"
            :label="'name'"
            :multiple="true"
            :showLabels="false"
            :close-on-select="false"
            :clear-on-select="false"
            placeholder=""
            group-label="label"
            group-values="options"
            :group-select="true"
        >
          <template #selection="slotProps">
            <span v-if="countStudents() > 0 && slotProps.values.length === countStudents()">Todos os estudantes</span>
            <span v-else-if="slotProps.values.length > 0">{{ slotProps.values.length }} estudante{{ slotProps.values.length > 1 ? 's' : '' }} selecionado{{ slotProps.values.length > 1 ? 's' : '' }}</span>
            <span v-else>Selecione os estudantes</span>
          </template>
          <template #beforeList>
            <div class="m-2 flex justify-self-center" v-if="countStudents() > 0">
              <button @click="onSelectAllStudents"
                      v-if="selectedStudents.length === 0"
                      class="btn btn-secondary">Selecionar todos
              </button>

              <button @click="onUnselectAllStudents"
                      v-else
                      class="btn btn-secondary">Deselecionar todos
              </button>
            </div>
          </template>

          <template #noOptions>
            <div class="flex justify-self-center">
              <span>Sem Alunos</span>
            </div>
          </template>
        </Multiselect>
      </div>

      <div class="col-3 mb-3">
        <label for="yearFromSelect">Período</label>

        <div class="d-flex gap-2 align-items-center justify-content-evenly">
          <Multiselect
              class="multiselectCustom"
              id="yearFromSelect"
              v-model="selectedPeriod"
              :options="periods"
              :track-by="'values'"
              :label="'label'"
              :allow-empty="false"
              selectedLabel="Selecionado"
              :showLabels="false"
              placeholder="Ano inicial"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="d-flex align-items-center justify-content-center gap-3 mb-1">
        <button @click="fetchPanelData"
                :disabled="isLoadingTeachers || isLoadingBranches || isLoadingCourseTypes || isLoadingClasses || isLoadingStudents || isFetchingPanelData"
                class="btn btn-primary custom-background-blue">
          <i class="bi bi-search"></i> Pesquisar
        </button>

        <button @click="clearFilters"
                :disabled="isLoadingTeachers || isLoadingBranches || isLoadingCourseTypes || isLoadingClasses || isLoadingStudents || isFetchingPanelData"
                class="btn btn-secondary">
          <i class="bi bi-x-lg"></i> Limpar
        </button>
      </div>

      <div class="d-flex align-items-center justify-content-center mb-1">
        <span v-if="errorMessage" class="text-danger small">{{ errorMessage }}</span>
        <span v-else :style="{height: '21px'}"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import Multiselect from 'vue-multiselect'
import {defineEmits, defineExpose, onMounted, ref} from 'vue'
import {useAuthStore} from "@/stores/auth";
import PanelService from "@/services/panel.service";
import ErrorUtils from "@/utils/error.utils";

const authStore = useAuthStore();
const emit = defineEmits(['dataFetched']);

const hasOnlyOneTeacher = ref(false);
const isLoadingTeachers = ref(true);
const isLoadingBranches = ref(true);
const isLoadingLaboratories = ref(true);
const isLoadingCourseTypes = ref(true);
const isLoadingClasses = ref(true);
const isLoadingStudents = ref(true);
const isFetchingPanelData = ref(false);

const selectedTeacher = ref(null);
const selectedBranches = ref([]);
const selectedLaboratories = ref([]);
const selectedCourseTypes = ref([]);
const selectedClasses = ref([]);
const selectedStudents = ref([]);
const selectedPeriod = ref(null);

const teachers = ref([]);
const branches = ref([]);
const laboratories = ref([]);
const courseTypes = ref([]);
const classes = ref([]);
const periods = ref([]);

const errorMessage = ref("");

const setErrorMessage = (message) => {
  errorMessage.value = message;
}

defineExpose({
  selectedStudents,
  selectedPeriod,
  setErrorMessage,
  fetchPanelData
});

const onSelectAllBranches = () => {
  selectedBranches.value = branches.value;
  fetchClasses();
}

const onUnselectAllBranches = () => {
  selectedBranches.value = [];
  fetchClasses();
}

const onSelectAllLaboratories = () => {
  selectedLaboratories.value = laboratories.value;
}

const onUnselectAllLaboratories = () => {
  selectedLaboratories.value = [];
}

const onSelectAllCourseTypes = () => {
  selectedCourseTypes.value = courseTypes.value;
  fetchClasses();
}

const onUnselectAllCourseTypes = () => {
  selectedCourseTypes.value = [];
  fetchClasses();
}

const onSelectAllClasses = () => {
  selectedClasses.value = classes.value;
  fetchStudents();
}

const onUnselectAllClasses = () => {
  selectedClasses.value = [];
  fetchStudents();
}

const onSelectAllStudents = () => {
  fetchStudents();
}

const onUnselectAllStudents = () => {
  selectedStudents.value = [];
}

function setLoggedInUserAsSelectedTeacher() {
  const loggedInUser = authStore.getLoggedInUsernameAndName();
  const username = loggedInUser?.username;
  const name = loggedInUser?.name;

  selectedTeacher.value = teachers.value.find(teacher => teacher.username === username);

  if (!selectedTeacher.value) {
    teachers.value.push({
          name: name,
          username: username
        }
    )
    selectedTeacher.value = teachers.value.find(teacher => teacher.username === username);
  }
}

async function fetchTeachers() {
  return PanelService.getTeachers()
      .then(response => {
        teachers.value = response.data;
        setLoggedInUserAsSelectedTeacher();
        hasOnlyOneTeacher.value = teachers.value.length === 1 && selectedTeacher.value === teachers.value[0];
      })
      .catch(error => errorMessage.value = ErrorUtils.toMessage(error));
}

async function fetchLaboratories() {
  isLoadingLaboratories.value = true;
  return PanelService.getLaboratories()
      .then(response => {
        laboratories.value = response.data;
        selectedLaboratories.value = laboratories.value;
      })
      .catch(error => errorMessage.value = ErrorUtils.toMessage(error))
      .finally(() => isLoadingLaboratories.value = false);
}

async function fetchBranches() {
  isLoadingBranches.value = true;
  isLoadingClasses.value = true;
  isLoadingStudents.value = true;

  branches.value = [];
  selectedBranches.value = [];

  return PanelService.getBranches(selectedTeacher.value)
      .then(response => {
        if (!selectedTeacher.value) {
          return;
        }

        branches.value = response.data;
        selectedBranches.value = branches.value;
      })
      .catch(error => errorMessage.value = ErrorUtils.toMessage(error))
      .finally(() => {
        isLoadingBranches.value = false;
        isLoadingClasses.value = false;
        isLoadingStudents.value = false;
      });
}

async function fetchCourseTypes() {
  isLoadingCourseTypes.value = true;

  courseTypes.value = [];
  selectedCourseTypes.value = [];

  return PanelService.getCourseTypes()
      .then(response => {
        courseTypes.value = response.data;
        selectedCourseTypes.value = courseTypes.value;
      })
      .catch(error => errorMessage.value = ErrorUtils.toMessage(error))
      .finally(() => isLoadingCourseTypes.value = false);
}

async function fetchClasses() {
  isLoadingClasses.value = true;
  isLoadingStudents.value = true;

  classes.value = [];
  selectedClasses.value = [];

  selectedStudents.value = [];

  return PanelService.getClasses(selectedTeacher.value, selectedBranches.value, selectedCourseTypes.value)
      .then(response => {
        if (!selectedTeacher.value) {
          return;
        }

        classes.value = response.data;
        selectedClasses.value = classes.value;

        fetchStudents();
      })
      .catch(error => errorMessage.value = ErrorUtils.toMessage(error))
      .finally(() => {
        isLoadingClasses.value = false;
        isLoadingStudents.value = false;
      });
}

async function fetchStudents() {
  isLoadingStudents.value = true;
  selectedStudents.value = [];

  if (!selectedClasses.value.length) {
    isLoadingStudents.value = false;
    return;
  }

  selectedStudents.value = getStudents()
      .map(group => group.options)
      .flat()
      .filter((student, index, array) => array.findIndex(s => s.username === student.username) === index);

  isLoadingStudents.value = false;
}

async function fetchPanelData(shouldDisplayErrorMessage = true) {
  errorMessage.value = "";
  if (selectedStudents.value.length === 0 && shouldDisplayErrorMessage) {
    errorMessage.value = "Selecione ao menos um estudante.";
    return;
  }

  isFetchingPanelData.value = true;
  PanelService.fetchData(selectedStudents.value, selectedPeriod.value, selectedLaboratories.value)
      .then(response => emit('dataFetched', response.data))
      .catch(error => errorMessage.value = ErrorUtils.toMessage(error))
      .finally(() => isFetchingPanelData.value = false);
}

function getStudents() {
  return selectedClasses.value.map(clazz => ({
    label: clazz.name,
    options: clazz.students || []
  })).filter(group => group.options.length > 0);
}

const countStudents = () => {
  return selectedClasses.value.reduce((acc, clazz) => acc + (clazz.students?.length || 0), 0);
}

const populatePeriods = () => {
  const currentYear = new Date().getFullYear();
  periods.value = [];

  for (let year = 2024; year < currentYear; year++) {
    periods.value.push({
      label: `${year} - ${year + 1}`,
      values: {
        from: `${year}`,
        to: `${year + 1}`
      }
    });
  }

  if (!selectedPeriod.value) {
    const thisYearPeriod = periods.value.filter(p => p.values.to === `${currentYear}`);
    selectedPeriod.value = thisYearPeriod.length > 0 ? thisYearPeriod[0] : null;
  }
};

function clearFilters() {
  if (!hasOnlyOneTeacher.value) {
    selectedTeacher.value = null;
  }

  selectedBranches.value = [];
  selectedLaboratories.value = laboratories.value;
  selectedCourseTypes.value = [];
  selectedClasses.value = [];
  selectedStudents.value = [];
  populatePeriods();
}

const onTeacherChange = async () => {
  await fetchBranches();
  selectedCourseTypes.value = courseTypes.value;
  await fetchClasses();
  await fetchStudents();
}

const onBranchChange = async () => {
  await fetchClasses();
  await fetchStudents();
}

const onCourseTypeChange = async () => {
  await fetchClasses();
  await fetchStudents();
}

const onClassChange = async () => {
  await fetchStudents();
}

onMounted(async () => {
  await fetchTeachers();

  isLoadingTeachers.value = false;

  populatePeriods();
  await fetchLaboratories();
  await fetchBranches();
  await fetchCourseTypes();
  await fetchClasses();
  await fetchStudents();
  await fetchPanelData(false);
});

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.multiselectCustom::v-deep .multiselect__tags {
  max-height: 43px;
  overflow: auto;
  overflow-x: hidden;
}

.multiselectCustom::v-deep .multiselect__tag {
  background-color: #1A5FD5;
  margin-top: 0;
}

.multiselectCustom::v-deep .multiselect__tag-icon::after {
  color: white;
}

.multiselectCustom::v-deep .multiselect__option--highlight,
.multiselectCustom::v-deep .multiselect__option--highlight:after {
  background-color: #1A5FD5;
  color: white !important;
}

.multiselectCustom::v-deep .multiselect__option--selected {
  color: #1A5FD5;
}

.multiselectCustom::v-deep .multiselect__option {
  max-width: 310px !important;
}

.multiselectCustom::v-deep .multiselect__content-wrapper {
  overflow-x: hidden;
}

.multiselectCustom::v-deep .multiselect__spinner::before,
.multiselectCustom::v-deep .multiselect__spinner::after {
  border-color: #1A5FD5 transparent transparent;
}

</style>